// src/config/native.js
// Configuration for native (iOS/Android) builds
// 
// For iOS builds, you can bundle credentials by setting environment variables
// before building. These are only used as a fallback when the API is unavailable.
//
// To build with bundled credentials:
// REACT_APP_PUBLIC_IDENTIFIER=your-handle.bsky.social REACT_APP_PUBLIC_PASSWORD=app-password npm run build

// Remote API URL - set this to your Vercel deployment URL
export const API_URL = process.env.REACT_APP_API_URL || 'https://govsky.app';

// Bundled credentials for fallback (only used if API is unreachable)
// These are read-only credentials for a public access account
export const BUNDLED_CREDENTIALS = {
  identifier: process.env.REACT_APP_PUBLIC_IDENTIFIER || '',
  password: process.env.REACT_APP_PUBLIC_PASSWORD || '',
};

// Check if bundled credentials are available
export const hasBundledCredentials = () => {
  return Boolean(BUNDLED_CREDENTIALS.identifier && BUNDLED_CREDENTIALS.password);
};

